import React, { useState, useEffect, useRef } from 'react'
import { Row, Col, Button } from 'react-bootstrap';
import {  useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import { useGetTeacherNewQuestionQuery } from '../../slices/teachers/teacherQuestionsApiSlice';
import TeacherHeader from '../../components/TeacherHeader';
import ReactMarkdown from 'react-markdown'
import VideoJS from '../../components/VideoJs';
import TeacherNavbar from '../../components/TeacherNavbar';
import Loader from '../../components/Loader';
import Message from '../../components/Message';

const TeacherWatchNew = () => {

    const playerRef = useRef(null);

    const navigate = useNavigate();

    const { id } = useParams();

    const { teacherInfo } = useSelector((state) => state.authTeacher);

    const { data, isLoading, error } = useGetTeacherNewQuestionQuery(id);

    useEffect(() => {
        if(!teacherInfo) {
            navigate('/teacherlogin')
        }
    }, [navigate, teacherInfo])

    const videoJsOptions = {
        autoplay: true,
        controls: true,
        responsive: true,
        fluid: true,
        sources: [{
          src: `https://bucketeer-f3a53e81-2e13-49e9-82ca-c504e025aced.s3.amazonaws.com/public/questions/${data?.mediaId}`,
          type: 'video/mp4'
        }]
    };

    const handlePlayerReady = (player) => {
        playerRef.current = player;
        player.on('waiting', () => {});
        player.on('dispose', () => {});
    };

  return (
    <div>
        <TeacherNavbar />
            <div className="main-content" id="panel">
            <TeacherHeader /><br /><br /><br />       
                <div className="container-fluid mt--6">
                    {isLoading ? ( 
                        <Loader />
                    ) : error ? (
                        <Message variant='danger'>
                            {error?.data?.message || error.error}
                        </Message>
                    ) : (
                        <div className="row">
                            <div className="col-xl-10 offset-xl-1">                               
                                <div className="card mycard">
                                    <h3 className="tittleColor videoTitle">
                                        <span className='tittleColor' style={{textTransform: 'capitalize'}}>
                                            {data?.subjectname}    
                                        </span>
                                    </h3>                                                                        
                                    <VideoJS 
                                      options={videoJsOptions} 
                                      onReady={handlePlayerReady} 
                                      cssRule="card-img-top"
                                    />
                                    <div className="card-body ">
                                        <h5 className="h4 card-title mb-0 mycard">
                                            <span className='tittleColor4'>{data?.tittle}</span>
                                            <p className="text-muted ">{data?.description}</p>
                                        </h5>                                                                                                                
                                        <LinkContainer to={`/teacheranswerdetails/${id}`} className='btn btn-default '>
                                            <Button variant="primary  bg-gradient-info"> Answer Question</Button>
                                        </LinkContainer><br /><br />
                                        <LinkContainer to={`/teacheraianswer/${id}`} className='btn btn-default '>
                                            <img src='https://cdn-icons-png.flaticon.com/512/14313/14313824.png' 
                                                alt='logo' 
                                                className='aiHelper1' 
                                            />
                                        </LinkContainer>
                                        <LinkContainer to={`/teacheraianswer/${id}`} className='btn btn-default '>
                                            <span className='aiHelperText'> Ask AI Assistance help with this question </span>                                            
                                        </LinkContainer>                                        
                                        <br /><br /><br />                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>        
            </div>      
    </div>
  )
}

export default TeacherWatchNew
